import styled from "@emotion/styled";
import { Colors } from "../../Themes";

const LogoText = styled.div`
  font-family: "PB", sans-serif;
  font-size: 3.75em;
  color: ${Colors.cmmsBlue};
  text-align: center;
`;

export default LogoText;



// WEBPACK FOOTER //
// ./src/Components/Text/LogoText.tsx